import { useContext, useEffect } from 'react';
import constants from '../../constants';
import Select from '../../ui/Select';
import { formatLclFcl, formatShipmentType, unFormatLclFcl } from './utils/formatUtils';
import { formatDateTime } from '../../dateUtils';

import OrchidTracking_Y from '../../img/orchid_tracking-yellow.svg';
import OrchidTracking_R from '../../img/orchid_tracking-red.svg';
import OrchidTracking_B from '../../img/orchid_tracking-blue.svg';
import OrchidTracking_G from '../../img/orchid_tracking-green.svg';

import railYellow from '../../img/rail-yellow.svg';
import railGreen from '../../img/rail-green.svg';
import railBlue from '../../img/rail-blue.svg';
import railRed from '../../img/rail-red.svg';

import cntrYellow from '../../img/container_tracking-yellow.svg';
import cntrGreen from '../../img/container_tracking-green.svg';
import cntrBlue from '../../img/container_tracking-blue.svg';
import cntrRed from '../../img/container_tracking-red.svg';
import ApplicationContext from '../../ApplicationContext';
import { getFmsGlobal } from '../../globals';
import { JobNames } from '../../framework.core/JobNames';

export function BillingsRenderer({ cell }: any) {
  let tempBillingsTooltip = '';
  switch (cell.value) {
    case 'I':
      tempBillingsTooltip = 'Issued';
      break;
    case 'E':
      tempBillingsTooltip = 'Empty';
      break;
    case 'D':
      tempBillingsTooltip = 'Draft';
      break;
  }
  return (
    <div id={`billings-renderer-${cell.column.dataIndex}`} className="ifms-table-default" data-tooltip={tempBillingsTooltip}>{cell.value}</div>
  );
}

export function PeriodRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default" data-tooltip="Period">{cell.value}</div>
  );
}


export function RecognizedRenderer({ cell }: any) {
  return (
    <div id="recognized_renderer" className="ifms-table-default" data-tooltip="Recognize">{cell.value}</div>
  );
}

export function TrackEventNameRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const lastEventDate = (l as any).lastEventDate as string;

  return (
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize">
      {cell.value} {formatDateTime(lastEventDate)}
    </div>
  );
}

export function ShipmentTypeRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default" >{formatShipmentType(cell.value)}</div>
  );
}

export function LastEventRenderer({ cell, row, data, jobName }: any) {
  const l = data[row.index];
  const lastEventDate = (l as any).lastEventDate as string;
  const trDate = (l as any).trDate as string;
  const appContext = useContext(ApplicationContext);
  const trStatus = cell.value;
  const lastEvent = (l as any).lastEvent as string;
  const fmsGlobal = getFmsGlobal();
  let imgSrc = null;

  let tooltip = '';
  let displayText = '';
  let displayDateTime = '';
  let id = '';
  let params = ''

  switch (jobName) {
    case JobNames.OIMbl:
    case JobNames.OtherOP:
      params = `&mbl=${cell.row.original.mblNo}`;
      break;
    case JobNames.OIHbl:
      params = `&hbl=${cell.row.original.hblNo}`;
      break;
    case JobNames.OIContainer:
    case JobNames.OtherContainer:
      params = `&cntr=${cell.row.original.containerNo}`;
      break;
  }

  let link = `https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}${params}&email=${appContext.user?.email}`;
  
  if ((cell.row.original.trType === 'M' || cell.row.original.trType === 'C')) {
    switch (trStatus) {
      case 'Q':
        displayText = 'Start to Request';
        displayDateTime = trDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrYellow;
        id = 'cntrYellowIcon';
        break;
      case 'failed':
        displayText = 'Invalid or Error';
        displayDateTime = trDate;
        tooltip = `${(l as any).trStatusDesc as string} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrRed;
        id = 'cntrRedIcon';
        break;
      case 'tracking_stopped':
        displayText = lastEvent;
        displayDateTime = lastEventDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrBlue;
        id = 'cntrBlueIcon';
        break;
      case 'pending':
        displayText = 'Pending';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
      case 'awaiting_manifest':
        displayText = 'Awaiting Manifest';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
      default:
        displayText = lastEvent;

        if (displayText != null && displayText.includes('eta')) displayText = displayText.replaceAll('eta', 'ETA');

        displayDateTime = lastEventDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
    }

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize"
      style={{ display: 'flex', alignItems: 'center' }}
      data-tooltip={tooltip} >
      <img style={{ cursor: 'pointer', float: 'left' }} height="16px" id={id} src={imgSrc} alt='' onClick={() => {
        window.open(link);
      }} />
      <div style={{ paddingLeft: '5px' }}>
        {displayText} {formatDateTime(displayDateTime)}
      </div>
    </div>
  } else {
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize" style={{ display: 'flex', alignItems: 'center' }}>
    </div>
  }
}

export function ShipmentTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-shipmentType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'D - Direct Shipment', value: 'D' },
        { label: 'ID - InDirect Shipment', value: 'ID' },
        { label: 'A.EDI', value: 'A.EDI' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function LclFclRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default">{formatLclFcl(cell.value)}</div>
  );
}

export function LclFclFilterRenderer({ value, onChange, onEnter }: any) {
  useEffect(() => {
    if (value !== unFormatLclFcl(value)) {
      onChange(unFormatLclFcl(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Select
      name='ifms-filter-cargo-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'L', label: 'Consol' },
        { value: 'F', label: 'FCL' },
        { value: 'O', label: 'LCL' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function BillInvoiceCrdbFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-billInvoiceCrdb-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'E', label: 'E - Empty' },
        { value: 'I', label: 'I - Issued' },
        { value: 'D', label: 'D - Draft' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function RecognizedFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      value={value}
      name='ifms-filter-recognize-select'
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'R', label: 'Recognize' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function TaxIdTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-taxIdType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'E', label: 'EIN - IRS Number' },
        { value: 'C', label: 'CBP - CBP Assigned Number' },
        { value: 'S', label: 'SSN - Social Security Number' },
        { value: 'O', label: 'OC - Organization Code' },
        { value: 'U', label: 'USCI - United Social Credit Identifier' },
        { value: 'R', label: 'EORI - Economic Operator Reg. ID' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

//Empty Renderer
export function StatusNotUseFileLockedRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-statusNotUse-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function DraftFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-draft-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'D', label: 'D - Draft' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function VoidFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-void-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'V', label: 'V - Void' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function InactiveFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-inactive-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'V', label: 'V - Inactive' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function CTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-cType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'C', label: 'Customer' },
        { value: 'ST', label: 'Ship To' },
        { value: 'SF', label: 'Ship From' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

// export function HeaderTooltipRenderer(caption: string, tooltip: string) {
//   return (
//     <div data-tooltip-position="listview-header" style={{ width: '100%' }} data-tooltip={tooltip}>{caption}</div>
//   );
// }

/**
 * Type Filter renderer for Bill, Invoice, CrDb list screens
 *
 * @export
 * @param {*} {opType, value, onChange}
 * @return {*} 
 */
export function BicTypeFilterRenderer({ opType, value, onChange, onEnter, acctType }: any) {
  const items = [];
  switch (opType) {
    case constants.opTypes.oceanImport:
      items.push(...[
        { label: 'OIM', value: 'OIM' },
        { label: 'OIH', value: 'OIH' },
      ]);
      break;
    case constants.opTypes.oceanExport:
      items.push(...[
        { label: 'OEM', value: 'OEM' },
        { label: 'OEH', value: 'OEH' },
      ]);
      break;
    case constants.opTypes.airImport:
      items.push(...[
        { label: 'AIM', value: 'AIM' },
        { label: 'AIH', value: 'AIH' },
      ]);
      break;
    case constants.opTypes.airExport:
      items.push(...[
        { label: 'AEM', value: 'AEM' },
        { label: 'AEH', value: 'AEH' },
      ]);
      break;
    case constants.opTypes.otherShipment:
      items.push(...[
        { label: 'OTH', value: 'OTH' },
      ]);
      break;
    case constants.opTypes.warehousing:
      items.push(...[
        { label: '', value: '' },
        { label: 'WHR', value: 'WHR' },
        { label: 'WHS', value: 'WHS' },
      ]);
      break;
    // case constants.opTypes.brokerageTrucking:
    //   if(acctType==='INV'){
    //     items.push(...[
    //       { label: 'BTO', value: 'BTO' },
    //       { label: 'BTL', value: 'BTL' },
    //     ]);
    //   } else if (acctType === 'BIL'){
    //     items.push(...[
    //       { label: 'BTO', value: 'BTO' },
    //       { label: 'BTL', value: 'BTL' },
    //     ]);
    //   }
    //   break;
    default:
      items.push(...[
        //{ label: 'AIM', value: 'AIM' },
        //{ label: 'AIH', value: 'AIH' },
        //{ label: 'AEM', value: 'AEM' },
        //{ label: 'AEH', value: 'AEH' },
        //{ label: 'OIM', value: 'OIM' },
        //{ label: 'OIH', value: 'OIH' },
        //{ label: 'OEM', value: 'OEM' },
        //{ label: 'OEH', value: 'OEH' },
        //{ label: 'OTH', value: 'OTH' },
        { label: 'ODM', value: 'ODM' },
        { label: 'ODL', value: 'ODL' },
        { label: 'WHR', value: 'WHR' },
        { label: 'WHS', value: 'WHS' },
      ]);
      break;
  }
  return (
    <Select
      name='ifms-filter-bicType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={items}
      applySearchWithEnter={onEnter}
    />
  );
}

export function RQFilterRenderer({ value, onChange, onEnter }: any) {
    return (
        <>
            <Select
                name='ifms-filter-rqcol-select'
                value={value}
                onChange={e => onChange(e.target.value)}
                items={[
                    { value: '', label: '' },
                    { value: 'Q', label: 'Start to Request', icon: cntrYellow },
                    { value: 'created', label: 'Under Movement', icon: cntrGreen },
                    { value: 'tracking_stopped', label: 'End of Tracking', icon: cntrBlue },
                    { value: 'failed', label: 'Invalid or Error', icon: cntrRed },
                ]}
                applySearchWithEnter={onEnter}
            />
        </>
    );
}

export function TrStatus2FilterRenderer({ value, onChange, onEnter }: any) {
    return (
        <Select
            name='ifms-filter-track-select'
            value={value}
            onChange={e => onChange(e.target.value)}
            items={[
                { value: '', label: '' },
                { value: 'Q', label: 'Start to Request', icon: cntrYellow },
                { value: 'created', label: 'Under Movement', icon: cntrGreen },
                { value: 'tracking_stopped', label: 'End of Tracking', icon: cntrBlue },
                { value: 'failed', label: 'Invalid or Error', icon: cntrRed },
            ]}
            applySearchWithEnter={onEnter}
        />
    );
}

export function MOTFilterRenderer({value, onChange, onEnter}: any){
  return (
    <Select
      name='ifms-filter-mot-select'
      value={value}
      onChange={ e => onChange(e.target.value)}
      items={[
        {value:'Ocean', label:'Ocean'},
        {value:'Rail', label:'Rail'},
        {value:'Truck', label:'Truck'},
        {value:'Air', label:'Air'},
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}